module.exports = __webpack_public_path__ + "static/media/Salesforce.d68d4903.svg";